module.exports = __webpack_public_path__ + "static/media/icon-download.909dea62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-download.svg
// module id = 949
// module chunks = 0